module.exports = __webpack_public_path__ + "img/icon_loan.79cf04ea.svg";